<template>
  <div
    ref="dashboardContainer"
    class="v2-dashboard-container"
    :class="[
      {
        'v2-dashboard-mobile': isMobile,
        'v2-dashboard-small': isSmall,
        'v2-dashboard-medium': isMedium,
        'v2-dashboard-large': isLarge,
        'v2-dashboard-xl': isXl
      }
    ]"
  >
    <div
      v-if="!isMobile && !isSmall"
      class="v2-dashboard-general-filter"
      style="margin-bottom: 20px;"
    >
      <FilterContainer>
        <template #main1>
          <field :label="'Filter by'">
            <control :options="filterType" v-model="filter.filter_type" />
          </field>

          <field v-if="(filter.filter_type == 'academic') || (filter.filter_type == 'semester')" :label="$t('class.academicYear')">
            <control :options="academicYearFilter" v-model="filter.academic_year_id" />
          </field>

          <field v-if="filter.filter_type == 'semester'" :label="'Semester'">
            <control :options="semesterListFilter" v-model="filter.semester_id" />
          </field>

          <field v-if="filter.filter_type == 'date'" :label="'Date Range'">
            <Datepicker v-model="filter.date_range" range :auto-apply="true" />
          </field>

          <field :label="''">
            <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="filterData()" />
          </field>
        </template>
      </FilterContainer>
    </div>

    <div
      v-if="!isMobile"
      class="v2-dashboard-section1"
    >
      <div class="v2-dashboard-section1-1">
        <SectionComboard
          :comboardLoad="comboardLoad"
          :comboardMerged="mergedComboard"
          :containerWidth="containerWidth"
          :containerHeight="containerHeight"
          :isMobile="isMobile"
          :isSmall="isSmall"
          :isMedium="isMedium"
          :isLarge="isLarge"
          :isXl="isXl"
          @refresh-comboard="getComboard"
        />

        <SectionEvent
          :eventLoad="eventLoad"
          :eventData="eventData"
          :eventUpcoming="eventUpcoming"
          :containerHeight="containerHeight"
          :isMobile="isMobile"
          :isSmall="isSmall"
          :isMedium="isMedium"
          :isLarge="isLarge"
          :isXl="isXl"
        />
      </div>

      <div class="v2-dashboard-section1-2">
        <TotalTeacher
          :totalStudentsDept="totalStudentsDept"
          :totalStudents="totalStudents"
          :totalEmoloyees ="totalEmoloyees"
        />

        <TotalStudent
          :totalStudentsDept="totalStudentsDept"
          :totalStudents="totalStudents"
          :totalEmoloyees ="totalEmoloyees"
        />
      </div>

      <!-- <div v-if="!isMobile && !isSmall" class="v2-dashboard-general-filter">
        <FilterContainer>
          <template #main1>
            <field :label="'Filter by'">
              <control :options="filterType" v-model="filter.filter_type" />
            </field>

            <field v-if="(filter.filter_type == 'academic') || (filter.filter_type == 'semester')" :label="$t('class.academicYear')">
              <control :options="academicYearFilter" v-model="filter.academic_year_id" />
            </field>

            <field v-if="filter.filter_type == 'semester'" :label="'Semester'">
              <control :options="semesterListFilter" v-model="filter.semester_id" />
            </field>

            <field v-if="filter.filter_type == 'date'" :label="'Date Range'">
              <Datepicker v-model="filter.date_range" range :auto-apply="true" />
            </field>

            <field :label="''">
              <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="filterData()" />
            </field>
          </template>
        </FilterContainer>
      </div> -->

      <div class="v2-dashboard-section1-3">
        <div
          v-if="(viewState === 'admin_view') || (viewState === 'internal_view')"
          class="v2-dashboard-section1-31"
          :class="{'v2-dashboard-section1-31internal' : (viewState === 'internal_view') && isXl}"
        >
          <SectionTeacherAttendance
            :dataLoad="loadAttendanceTeacher"
            :attendanceSummary="attendanceSummary"
            :attendanceFilter="attendanceFilter"
            :attendanceEmployee="attendanceEmployee"
            :filterParams="filter"
          />

          <div class="teacher-list-outer">
            <SectionTeacherTopList
              :listLabel="'Top 10 Tardy'"
              :listType="'late'"
              :listData="teacherTopLate"
              :listLoad="loadTopTeacher"
            />

            <SectionTeacherTopList
              :listLabel="'Top 10 Absent'"
              :listType="'absent'"
              :listData="teacherTopAbsent"
              :listLoad="loadTopTeacher"
            />
          </div>
        </div>

        <div
          v-if="(viewState === 'admin_view') || (viewState === 'teacher_view')"
          class="v2-dashboard-section1-32"
          :class="{'v2-dashboard-section1-3teacher' : (viewState === 'teacher_view') && isXl}"
        >
          <SectionStudentAttendance
            :studentAttendanceFilter="studentAttendanceData?.filter"
            :studentAttendanceData="studentAttendanceData?.data"
            :filterParams="filter"
          />

          <div v-if="isXl && (viewState !== 'teacher_view')" class="student-tabs-container">
            <div class="student-tab-content">
              <div
                v-for="tab in studentTabs"
                :key="tab"
                @click="studentTabActive = tab.id"
                class="student-tab"
                :class="{'student-tab-active' : studentTabActive === tab.id}"
              >
                <p>{{ tab.label }}</p>
              </div>
            </div>
          </div>

          <div v-if="isXl && (viewState !== 'teacher_view')" class="student-list-swap">
            <div
              class="student-list-swap-tabs"
              :style="[
                studentTabActive === 1 ? 'margin-left: -100%;'
                : studentTabActive === 2 ? 'margin-left: -200%;'
                : studentTabActive === 3 ? 'margin-left: -300%;'
                : 'margin-left: 0;'
              ]"
            >
              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'late'"
                :listData="studentAttendanceData?.tardy?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'permission'"
                :listData="studentAttendanceData?.permission?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'sick'"
                :listData="studentAttendanceData?.sick?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'absent'"
                :listData="studentAttendanceData?.absent?.student"
              />
            </div>
          </div>

          <div v-else class="student-list-outer">
            <SectionStudentTopList
              :listLoad="studentAttendanceLoad"
              :listType="'late'"
              :listData="studentAttendanceData?.tardy?.student"
            />

            <SectionStudentTopList
              :listLoad="studentAttendanceLoad"
              :listType="'permission'"
              :listData="studentAttendanceData?.permission?.student"
            />

            <SectionStudentTopList
              :listLoad="studentAttendanceLoad"
              :listType="'sick'"
              :listData="studentAttendanceData?.sick?.student"
            />

            <SectionStudentTopList
              :listLoad="studentAttendanceLoad"
              :listType="'absent'"
              :listData="studentAttendanceData?.absent?.student"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="isMobile" class="v2-dashboard-section-mobile">
      <div class="mobile-tabs-container">
        <div class="mobile-tab-content">
          <div
            v-for="tab in (viewState == 'teacher_view') ? dashboardTabsTeacher : (viewState == 'internal_view') ? dashboardTabsInternal : dashboardTabs"
            :key="tab"
            @click="tabActive = tab.id"
            class="mobile-tab"
            :class="{'mobile-tab-active' : tabActive === tab.id}"
          >
            <p>{{ tab.label }}</p>
          </div>
        </div>
      </div>

      <div class="mobile-container">
        <div
          class="mobile-container-outer"
          :style="[
            tabActive === 1 ? 'margin-left: -100vw;'
            : tabActive === 2 ? 'margin-left: -200vw;'
            : tabActive === 3 ? 'margin-left: -300vw;'
            : 'margin-left: 0;'
          ]"
        >
          <div
            class="mobile-container-inner"
            :class="{'mobile-container-inner-short' : tabActive !== 0}"
          >
            <SectionComboard
              :comboardLoad="comboardLoad"
              :comboardMerged="mergedComboard"
              :containerWidth="containerWidth"
              :containerHeight="containerHeight"
              :isMobile="isMobile"
              :isSmall="isSmall"
              :isMedium="isMedium"
              :isLarge="isLarge"
              :isXl="isXl"
              @refresh-comboard="getComboard"
            />
          </div>

          <div
            class="mobile-container-inner"
            :class="{'mobile-container-inner-short' : tabActive !== 1}"
          >
            <SectionEvent
              :eventLoad="eventLoad"
              :eventData="eventData"
              :eventUpcoming="eventUpcoming"
              :containerHeight="containerHeight"
              :isMobile="isMobile"
              :isSmall="isSmall"
              :isMedium="isMedium"
              :isLarge="isLarge"
              :isXl="isXl"
            />
          </div>

          <div
            v-if="viewState !== 'teacher_view'"
            class="mobile-container-inner"
            :class="{'mobile-container-inner-short' : tabActive !== 2}"
          >
            <div class="mobile-teacher-attendance">
              <SectionTeacherAttendance
                :dataLoad="loadAttendanceTeacher"
                :attendanceSummary="attendanceSummary"
                :attendanceFilter="attendanceFilter"
                :attendanceEmployee="attendanceEmployee"
                :filterParams="filter"
              />

              <TotalTeacher
                :totalStudentsDept="totalStudentsDept"
                :totalStudents="totalStudents"
                :totalEmoloyees ="totalEmoloyees"
              />

              <SectionTeacherTopList
                :listLabel="'Top 10 Tardy'"
                :listType="'late'"
                :listData="teacherTopLate"
                :listLoad="loadTopTeacher"
              />

              <SectionTeacherTopList
                :listLabel="'Top 10 Absent'"
                :listType="'absent'"
                :listData="teacherTopAbsent"
                :listLoad="loadTopTeacher"
              />
            </div>
          </div>

          <div
            v-if="(viewState !== 'internal_view') && (viewState !== 'teacher_view')"
            class="mobile-container-inner"
            :class="{'mobile-container-inner-short' : tabActive !== 3}"
          >
            <div class="mobile-student-attendance">
              <SectionStudentAttendance
                :studentAttendanceFilter="studentAttendanceData?.filter"
                :studentAttendanceData="studentAttendanceData?.data"
                :filterParams="filter"
              />

              <TotalStudent
                :totalStudentsDept="totalStudentsDept"
                :totalStudents="totalStudents"
                :totalEmoloyees ="totalEmoloyees"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'late'"
                :listData="studentAttendanceData?.tardy?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'permission'"
                :listData="studentAttendanceData?.permission?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'sick'"
                :listData="studentAttendanceData?.sick?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'absent'"
                :listData="studentAttendanceData?.absent?.student"
              />
            </div>
          </div>

          <div
            v-if="viewState !== 'internal_view'"
            class="mobile-container-inner"
            :class="{'mobile-container-inner-short' : tabActive !== 2}"
          >
            <div class="mobile-student-attendance">
              <SectionStudentAttendance
                :studentAttendanceFilter="studentAttendanceData?.filter"
                :studentAttendanceData="studentAttendanceData?.data"
                :filterParams="filter"
              />

              <TotalStudent
                :totalStudentsDept="totalStudentsDept"
                :totalStudents="totalStudents"
                :totalEmoloyees ="totalEmoloyees"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'late'"
                :listData="studentAttendanceData?.tardy?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'permission'"
                :listData="studentAttendanceData?.permission?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'sick'"
                :listData="studentAttendanceData?.sick?.student"
              />

              <SectionStudentTopList
                :listLoad="studentAttendanceLoad"
                :listType="'absent'"
                :listData="studentAttendanceData?.absent?.student"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isMobile" @click="openFilterContent()" class="v2-filter-mobile">
    <icon :path="mdiFilterMultipleOutline" :w="'w-6'" :h="'h-6'" />
  </div>

  <div v-if="openFilterMob" class="v2-filter-mobile-container">
    <FilterContainer>
      <template #main1>
        <field :label="'Filter by'">
          <control :options="filterType" v-model="filter.filter_type" />
        </field>

        <field v-if="(filter.filter_type == 'academic') || (filter.filter_type == 'semester')" :label="$t('class.academicYear')">
          <control :options="academicYearFilter" v-model="filter.academic_year_id" />
        </field>

        <field v-if="filter.filter_type == 'semester'" :label="'Semester'">
          <control :options="semesterListFilter" v-model="filter.semester_id" />
        </field>

        <field v-if="filter.filter_type == 'date'" :label="'Date Range'">
          <Datepicker v-model="filter.date_range" range :auto-apply="true" />
        </field>

        <field :label="''">
          <jb-button label="Search" color="info" :icon="mdiMagnify" small @click="filterData()" />
        </field>
      </template>
    </FilterContainer>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onBeforeUnmount, onMounted, onUnmounted, watch, watchEffect, computed } from 'vue'
  import { mdiClose, mdiMagnify, mdiFilterMultipleOutline } from '@mdi/js'
  import { useToast } from 'vue-toastification'
  import { useI18n } from 'vue-i18n'
  import { AgGridVue } from 'ag-grid-vue3'
  import axios from 'axios'
  import qs from "qs"
  import dayjs from 'dayjs'
  import Datepicker from "@vuepic/vue-datepicker"
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  import SectionComboard from './SectionComboard.vue'
  import SectionEvent from './SectionEvent.vue'
  import TotalTeacher from './TotalTeacher.vue'
  import TotalStudent from './TotalStudent.vue'
  import SectionTeacherAttendance from './SectionTeacherAttendance.vue'
  import SectionTeacherTopList from './SectionTeacherTopList.vue'
  import SectionStudentAttendance from './SectionStudentAttendance.vue'
  import SectionStudentTopList from './SectionStudentTopList.vue'
  import FilterContainer from "@/components/Container/FilterContainer.vue"
  import Field from '@/components/Field'
  import Control from '@/components/Control'
  import JbButton from '@/components/JbButton'
  import Icon from "@/components/Icon"

  import { getSchoolData, getBranchData, getCheckRoleUser } from '@/composables/global'

  export default {
    components: {
      SectionComboard,
      SectionEvent,
      TotalTeacher,
      TotalStudent,
      SectionTeacherAttendance,
      SectionTeacherTopList,
      SectionStudentAttendance,
      SectionStudentTopList,
      FilterContainer,
      Field,
      Control,
      JbButton,
      Datepicker,
      Icon
    },

    setup (props, { emit }) {
      const dashboardContainer = ref(null)
      const containerWidth = ref(0)
      const containerHeight = ref(0)
      let resizeObserver = null

      const viewState = ref(null)
      const determineView = () => {
        const roles = localStorage.getItem('roles') || ''

        if (
          roles.includes('ROLE_HEADMASTER') ||
          roles.includes('ROLE_DIRECTOR') ||
          roles.includes('ROLE_ADMIN_HRD') ||
          roles.includes('ROLE_MANAGEMENT')
        ) {
          viewState.value = 'internal_view'
        }
        else if (roles.includes('ROLE_SUPER_ADMIN') || roles.includes('ROLE_ADMIN')) {
          viewState.value = 'admin_view'
        }
        else if (
          roles.includes('ROLE_HOMEROOM') ||
          roles.includes('ROLE_TEACHER')
        ) {
          viewState.value = 'teacher_view'
        }
        else {
          viewState.value = null
        }
      }

      const isMobile = computed(() => containerWidth.value < 520)
      const isSmall = computed(() => containerWidth.value >= 520 && containerWidth.value < 768)
      const isMedium = computed(() => containerWidth.value >= 769 && containerWidth.value < 1024)
      const isLarge = computed(() => containerWidth.value >= 1024 && containerWidth.value < 1280)
      const isXl = computed(() => containerWidth.value >= 1280)

      const todayDate = ref("")
      const initAttendance = () => {
        const today = dayjs()

        const todayStart = today.format('YYYY-MM-DD')
        const todayEnd = today.format('YYYY-MM-DD')
        todayDate.value = todayStart

        const dayOfWeek = today.day()
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek

        const weekStart = today.add(diffToMonday, 'day').format('YYYY-MM-DD')
        const weekEnd = dayjs(weekStart).add(6, 'day').format('YYYY-MM-DD')

        const monthStart = today.startOf('month').format('YYYY-MM-DD')
        const monthEnd = today.endOf('month').format('YYYY-MM-DD')


        filter.start_date = todayDate.value
        filter.end_date = todayDate.value

        filterTeacherAttendance.start_date = todayDate.value
        filterTeacherAttendance.end_date = todayDate.value

        filterStudent.start_date = todayDate.value
        filterStudent.end_date = todayDate.value

        // getTeacherAttendance('today', todayStart, todayEnd)
        // getTeacherAttendance('week', weekStart, weekEnd)
        // getTeacherAttendance('month', monthStart, monthEnd)
      }

      onMounted(() => {
        determineView()

        resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            containerWidth.value = entry.contentRect.width
            containerHeight.value = entry.contentRect.height
          }
        })

        if (dashboardContainer.value) {
          resizeObserver.observe(dashboardContainer.value)
        }
      })

      onBeforeUnmount(() => {
        if (resizeObserver && dashboardContainer.value) {
          resizeObserver.unobserve(dashboardContainer.value)
        }
      })


      const filter = reactive({
        filter_type: "today",
        academic_year_id: "",
        semester_id: "",
        start_date: "",
        end_date: "",
        date_range: []
      })

      const filterType = ref([
        {
          id: "today",
          label: "Today"
        },
        {
          id: "date",
          label: "Date Range"
        },
        {
          id: "academic",
          label: "Academic Year"
        },
        {
          id: "semester",
          label: "Semester"
        },
      ])


      const { academicYearList, semesterList } = getCheckRoleUser({ id: localStorage.getItem("user_id") })

      const academicYearFilter = ref([])
      const mergeAcademicYear = (list = []) => {
        const map = {}

        list.forEach(item => {
          const match = item.name?.match(/\d{4}.*?\d{4}/)

          if (!match) return

          const years = match[0].match(/\d{4}/g)
          const key = `${years[0]}/${years[1]}`

          if (!map[key]) {
            map[key] = {
              id: key,
              label: key,
              ids: []
            }
          }

          map[key].ids.push(item.id)
        })

        return Object.values(map)
      }

      const mergeSemester = (list = []) => {
        const map = {}

        list.forEach(item => {
          const match = item.name?.toLowerCase().match(/semester\s*(\d+)/)

          if(!match) return

          const sem = match[1]

          if(!map[sem]){
            map[sem] = {
              id: sem,
              label: `Semester ${sem}`,
              ids: []
            }
          }

          map[sem].ids.push(item.id)
        })

        return Object.values(map)
      }

      const semesterListFilter = ref([])
      watch(academicYearList, (newAca) => {
        const active = (newAca ?? []).filter(item => item.is_active === 1)
        academicYearFilter.value = mergeAcademicYear(active)
      }, { immediate: true })

      watch(() => filter.academic_year_id, (newAca) => {
        const aca = academicYearFilter.value.find(i => i.id === newAca)

        if(!aca){
          semesterListFilter.value = []
          return
        }

        const filtered = semesterList.value.filter(item =>
          aca.ids.includes(item.academic_year_id)
        )

        semesterListFilter.value = mergeSemester(filtered)
      })


      const tabActive = ref(0)
      const studentTabActive = ref(0)

      const studentTabs = ref([
        {
          id: 0,
          label: "Tardy"
        },
        {
          id: 1,
          label: "Permission"
        },
        {
          id: 2,
          label: "Sick"
        },
        {
          id: 3,
          label: "Absent"
        },
      ])

      const dashboardTabs = ref([
        {
          id: 0,
          label: "Comboard"
        },
        {
          id: 1,
          label: "Upcoming Events"
        },
        {
          id: 2,
          label: "Teacher Attendance"
        },
        {
          id: 3,
          label: "Student Attendance"
        },
      ])

      const dashboardTabsInternal = ref([
        {
          id: 0,
          label: "Comboard"
        },
        {
          id: 1,
          label: "Upcoming Events"
        },
        {
          id: 2,
          label: "Teacher Attendance"
        },
      ])

      const dashboardTabsTeacher = ref([
        {
          id: 0,
          label: "Comboard"
        },
        {
          id: 1,
          label: "Upcoming Events"
        },
        {
          id: 2,
          label: "Student Attendance"
        },
      ])


      const filterComboard = reactive({
        school_id: localStorage.getItem('school_id'),
        branch_id: localStorage.getItem('branch_id'),
        user_parent_id: localStorage.getItem('user_id'),
        roles: localStorage.getItem('roles'),
        month: "",
        year: "",
        date: "",
        skip: ""
      })

      const comboardLoad = ref(false)
      const comboardData = ref([])
      const comboardComment = ref([])

      const mergedComboard = computed(() => {
        return comboardData.value.map(board => {
          const boardComments = comboardComment.value.filter(comment => comment.comboard_id === board.id)

          const parentComments = boardComments.filter(comment => !comment.detail_id)

          const commentsWithReplies = parentComments.map(parent => {
            const replies = boardComments.filter(reply => reply.detail_id === parent.id)

            return { ...parent, replies }
          })

          return {
            ...board,
            comments: commentsWithReplies,
            total_comments: boardComments.length
          }
        })
      })

      const getComboard = async () => {
        comboardLoad.value = true

        await axios.get('comboard-admin', {params: filterComboard})
        .then(response => {
          comboardData.value = response?.data?.data ?? []
          comboardComment.value = response?.data?.dataDetail ?? []

          comboardLoad.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }


      const filterTeacherAttendance = {
        user_id: localStorage.getItem('user_id'),
        school_id: localStorage.getItem('school_id'),
        branch_id: localStorage.getItem('branch_id'),
        academic_year_id: [],
        semester_id: [],
        employee_type: "teacher",
        start_date: "",
        end_date: ""
      }

      const loadAttendanceTeacher = ref(false)
      const attendanceFilter = ref({})
      const attendanceEmployee = ref({})
      const attendanceSummary = reactive({
        data: {},
        today: {},
        weekly: {},
        monthly: {},
        semester: []
      })

      const teacherTopSick = ref([])
      const teacherTopPermission = ref([])
      const teacherTopLeave = ref([])
      const teacherTopAbsent = ref([])
      const teacherTopLate = ref([])

      const getFilterTeacherAttendance = async () => {
        loadAttendanceTeacher.value = true

        await axios.get('employee-attendance-summary', {
          params: filterTeacherAttendance,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })
        .then(response => {
          // console.log("cek employee attendance", response?.data)
          attendanceEmployee.value = response?.data
          attendanceFilter.value = response?.data?.filter

          attendanceSummary.data = response?.data?.data
          attendanceSummary.today = response?.data?.today
          attendanceSummary.weekly = response?.data?.weekly
          attendanceSummary.monthly = response?.data?.monthly
          attendanceSummary.semester = response?.data?.semester

          teacherTopSick.value = response?.data?.sick ? response?.data?.sick : []
          teacherTopPermission.value = response?.data?.permission ? response?.data?.permission : []
          teacherTopLeave.value = response?.data?.leave ? response?.data?.leave : []
          teacherTopAbsent.value = response?.data?.absent ? response?.data?.absent : []
          teacherTopLate.value = response?.data?.tardy ? response?.data?.tardy : []

          loadAttendanceTeacher.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }

      // const getTeacherAttendance = async (type, start, end) => {
      //   loadAttendanceTeacher.value = true

      //   try {
      //     const response = await axios.get('employee-attendance-summary', {
      //       params: filterTeacherAttendance,
      //       paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
      //     })

      //     // attendanceFilter.value = response?.data?.filter

      //     attendanceSummary[type] = {
      //       data: response?.data?.data,
      //       sick: response?.data?.sick,
      //       permission: response?.data?.permission,
      //       absent: response?.data?.absent,
      //       leave: response?.data?.leave,
      //       semester: response?.data?.semester
      //     }

      //     loadAttendanceTeacher.value = false
      //   }
      //   catch (error) {
      //     console.log(`Error ${type}`, error)
      //   }
      // }


      const loadTopTeacher = ref(false)
      // const teacherTopSick = ref([])
      // const teacherTopPermission = ref([])
      // const teacherTopLeave = ref([])
      // const teacherTopAbsent = ref([])
      // const teacherTopLate = ref([])

      const getTeacherTop = () => {
        loadTopTeacher.value = true

        axios.get('employee-attendance-ranking', {
          params: filterTeacherAttendance,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })
        .then(response => {
          // console.log("cek lah ges", response?.data?.data)
          // teacherTopSick.value = response?.data?.data?.listSick
          // teacherTopPermission.value = response?.data?.data?.listPermission
          // teacherTopLeave.value = response?.data?.data?.listLeave
          // teacherTopAbsent.value = response?.data?.data?.listAbsent
          // teacherTopLate.value = response?.data?.data?.listTardy

          loadTopTeacher.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }


      const filterEvent = reactive({
        school_id: localStorage.getItem('school_id'),
        branch_id: localStorage.getItem('branch_id'),
        academic_year_id: [],
        semester_id: [],
        user_id: localStorage.getItem('user_id'),
        type: "event"
      })

      const eventLoad = ref(false)
      const eventData = ref([])
      const eventUpcoming = ref([])

      const getEvent = () => {
        eventLoad.value = true

        axios.get('calender', {
          params: filterEvent,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })
        .then(response => {
          eventData.value = response?.data?.data?.all
          eventUpcoming.value = response?.data?.data?.upcoming

          eventLoad.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }


      const filterStudent = reactive({
        school_id: localStorage.getItem('school_id'),
        branch_id: localStorage.getItem('branch_id'),
        academic_year_id: [],
        semester_id: [],
        start_date: "",
        end_date: ""

        // class_id: "",
        // level_id: "",
        // month: "",
        // year: "",
        // start_date: "2026-02-26",
        // end_date: "2026-02-26"
      })

      const studentAttendanceLoad = ref(false)
      const studentAttendanceData = ref([])

      const getStudentAttendance = () => {
        studentAttendanceLoad.value = true

        axios.get('student-attendance-summary', {
          params: filterStudent,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
        })
        .then(response => {
          studentAttendanceData.value = response?.data
          studentAttendanceLoad.value = false
        })
        .catch(error => {
          console.log(error)
        })
      }


      const filterTotalDatas = reactive({
        school_id: localStorage.getItem('school_id'),
        branch_id: localStorage.getItem('branch_id'),
        academic_year_id: [],
        semester_id: [],
      })

      const totalStudentsDept = ref([])
      const totalStudents = ref(0)
      const totalEmoloyees = ref([])

      const getTotalData = async () => {
        try {
          const response = await axios.get('/employee-student-total-datas', {
            params: filterTotalDatas,
            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
          })

          const prevStudents = response.data.data.students

          totalStudentsDept.value = prevStudents.total_students_from_department
          totalStudents.value = prevStudents.total_students_all
          totalEmoloyees.value = response.data.data.employees
        }
        catch(error) {
          console.error(error)
        }
      }

      const { schoolList } = getSchoolData()
      watch(schoolList, (newList) => {
        const prevSch = newList[0]

        if(!filterComboard.school_id) {
          const prevSchData = prevSch ? prevSch.id : ""
          filterComboard.school_id = prevSchData
          filterTeacherAttendance.school_id = prevSchData
          filterEvent.school_id = prevSchData
          filterStudent.school_id = prevSchData
          filterTotalDatas.school_id = prevSchData
        }
      })


      const { BranchDataList } = getBranchData()
      const branchList = ref([])
      watch(BranchDataList, (newBranch) => {
        if(newBranch) {
          branchList.value = newBranch.filter(function (item) { return item.school_id === filterComboard.school_id })

          if(!filterComboard.branch_id) {
            const prevSchData = branchList.value[1]?.id ?? ""

            filterComboard.branch_id = prevSchData
            filterEvent.branch_id = prevSchData
            filterTotalDatas.branch_id = prevSchData
            filterTeacherAttendance.branch_id = prevSchData
            filterStudent.branch_id = prevSchData

            // initAttendance()
            // getTotalData()
            // getTeacherTop()
            // getStudentAttendance()
            // getFilterTeacherAttendance()
          }
        }
      })

      onMounted(() => {
        initAttendance()
        getComboard()
        getEvent()
        getTotalData()
        getTeacherTop()
        getFilterTeacherAttendance()
        getStudentAttendance()
      })


      const getAcademicYearIds = () => {
        const aca = academicYearFilter.value.find(
          i => i.id === filter.academic_year_id
        )
        return aca?.ids ?? []
      }

      const getSemesterIds = () => {
        const sem = semesterListFilter.value.find(
          i => i.id === filter.semester_id
        )
        return sem?.ids ?? []
      }

      const filterData = () => {
        if(filter.filter_type == 'date') {
          if(filter.date_range.length > 1) {
            filterEvent.academic_year_id = []
            filterEvent.semester_id = []

            filterTotalDatas.academic_year_id = []
            filterTotalDatas.semester_id = []

            filter.start_date = filter.date_range[0].toISOString().slice(0, 10)
            filter.end_date = filter.date_range[1].toISOString().slice(0, 10)
            filter.academic_year_id = ""
            filter.semester_id = ""

            filterTeacherAttendance.start_date = filter.start_date
            filterTeacherAttendance.end_date = filter.end_date
            filterTeacherAttendance.academic_year_id = []
            filterTeacherAttendance.semester_id = []

            filterStudent.start_date = filter.start_date
            filterStudent.end_date = filter.end_date
            filterStudent.academic_year_id = []
            filterStudent.semester_id = []
          }
        }
        else if(filter.filter_type == 'academic') {
          const academicIds = getAcademicYearIds()

          filterEvent.academic_year_id = academicIds
          filterEvent.semester_id = []

          filterTotalDatas.academic_year_id = academicIds
          filterTotalDatas.semester_id = []

          filter.date_range = []
          filter.start_date = ""
          filter.end_date = ""
          // filter.academic_year_id = academicIds
          filter.semester_id = ""

          filterTeacherAttendance.start_date = ""
          filterTeacherAttendance.end_date = ""
          filterTeacherAttendance.academic_year_id = academicIds
          filterTeacherAttendance.semester_id = []

          filterStudent.start_date = ""
          filterStudent.end_date = ""
          filterStudent.academic_year_id = academicIds
          filterStudent.semester_id = []
        }
        else if(filter.filter_type == 'semester') {
          const academicIds = getAcademicYearIds()
          const semesterIds = getSemesterIds()

          filterEvent.academic_year_id = academicIds
          filterEvent.semester_id = semesterIds

          filterTotalDatas.academic_year_id = academicIds
          filterTotalDatas.semester_id = semesterIds

          filter.date_range = []
          filter.start_date = ""
          filter.end_date = ""
          // filter.academic_year_id = academicIds
          // filter.semester_id = semesterIds

          filterTeacherAttendance.start_date = ""
          filterTeacherAttendance.end_date = ""
          filterTeacherAttendance.academic_year_id = academicIds
          filterTeacherAttendance.semester_id = semesterIds

          filterStudent.start_date = ""
          filterStudent.end_date = ""
          filterStudent.academic_year_id = academicIds
          filterStudent.semester_id = semesterIds
        }
        else {
          filterEvent.academic_year_id = []
          filterEvent.semester_id = []

          filterTotalDatas.academic_year_id = []
          filterTotalDatas.semester_id = []

          filter.start_date = todayDate.value
          filter.end_date = todayDate.value
          filter.academic_year_id = ""
          filter.semester_id = ""

          filterTeacherAttendance.start_date = todayDate.value
          filterTeacherAttendance.end_date = todayDate.value
          filterTeacherAttendance.academic_year_id = []
          filterTeacherAttendance.semester_id = []

          filterStudent.start_date = todayDate.value
          filterStudent.end_date = todayDate.value
          filterStudent.academic_year_id = []
          filterStudent.semester_id = []
        }

        getEvent()
        getTotalData()
        getTeacherTop()
        getStudentAttendance()
        getFilterTeacherAttendance()
      }


      const openFilterMob = ref(false)
      const openFilterContent = () => {
        if(!openFilterMob.value) {
          openFilterMob.value = true
        } else {
          openFilterMob.value = false
        }
      }


      return {
        mdiMagnify,
        mdiFilterMultipleOutline,
        dashboardContainer,
        containerWidth,
        containerHeight,
        viewState,
        isMobile,
        isSmall,
        isMedium,
        isLarge,
        isXl,
        tabActive,
        dashboardTabs,
        dashboardTabsInternal,
        dashboardTabsTeacher,
        studentTabs,
        studentTabActive,
        comboardLoad,
        comboardData,
        comboardComment,
        mergedComboard,
        eventLoad,
        eventData,
        eventUpcoming,
        filterTeacherAttendance,
        attendanceFilter,
        attendanceEmployee,
        attendanceSummary,
        loadAttendanceTeacher,
        loadTopTeacher,
        teacherTopLeave,
        teacherTopAbsent,
        teacherTopLate,
        getComboard,
        studentAttendanceLoad,
        studentAttendanceData,
        filterTotalDatas,
        filter,
        filterType,
        semesterListFilter,
        academicYearFilter,
        academicYearList,
        semesterList,
        filterData,
        totalStudentsDept,
        totalStudents,
        totalEmoloyees,
        openFilterMob,
        openFilterContent
      }
    }
  }
</script>

<style lang="scss">
  .v2-dashboard-container {
    width: 100%;
    height: auto;
    min-height: calc(100dvh - 60px - 32px);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    .v2-dashboard-section1,
    .v2-dashboard-section2 {
      width: 100%;
      max-width: 1280px;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .v2-dashboard-section1 {
      .comboard-container {
        width: 100%;
        height: auto;
        position: relative;

        &::before {
          content: '';
          width: 100%;
          height: 40px;
          background-image: linear-gradient(to bottom, transparent, rgba(249, 250, 251));
          position: absolute;
          z-index: 3;
          bottom: 0;
          left: 0;
          pointer-events: none;
        }
      }
    }
  }

  .v2-dashboard-mobile {
    .v2-dashboard-section-mobile {
      width: 100%;
      height: auto;
      position: relative;

      .mobile-tabs-container {
        width: 100vw;
        max-width: 100vw;
        height: auto;
        background-color: rgba(249, 250, 251);
        overflow-x: auto;
        overflow-y: hidden;
        padding: 12px 0;
        position: fixed;
        top: 60px;
        left: 0;
        z-index: 3;

        .mobile-tab-content {
          width: max-content;
          min-width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 16px;
          padding: 0 16px;

          .mobile-tab {
            width: max-content;
            height: auto;
            background-color: #e4ecff;
            padding: 8px 16px;
            transition: background-color .3s;
            cursor: pointer;

            p {
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
              transition: color .3s;
            }
          }

          .mobile-tab-active {
            background-color: #152751;

            p {
              color: white;
            }
          }
        }
      }

      .mobile-container {
        width: 100%;
        max-width: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
        height: auto;

        .mobile-container-outer {
          width: max-content;
          height: auto;
          display: flex;
          flex-direction: row;
          align-items: start;
          padding-top: 68px;
          transition: margin-left .6s;

          .mobile-container-inner {
            width: 100vw;
            height: auto;
            min-height: 400px;

            .comboard-container {
              .comboard-container-outer {
                .comboard-content {
                  padding: 0 16px 40px 16px;
                  gap: 28px !important;

                  .comboard-card-content {
                    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px !important;
                  }
                }
              }
            }

            .event-container {
              padding: 0 16px 20px 16px;

              .event-container-outer {
                .event-content {
                  height: calc(100dvh - 200px - 40px - 40px - 20px) !important;
                }
              }
            }

            .mobile-teacher-attendance {
              padding: 0 16px 20px 16px;
              display: flex;
              flex-direction: column;
              gap: 40px;

              .total-teacher-container {
                background-color: white;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

                .total-content-outer {
                  height: max-content;
                  max-height: max-content;
                }
              }

              .attendance-container {
                .attendance-container-group {
                  margin-top: 40px;
                }
              }

              .list-rank-container {
                .event-container-outer {
                  .event-content {
                    height: max-content;
                    max-height: max-content;
                  }
                }
              }
            }

            .mobile-student-attendance {
              padding: 0 16px 20px 16px;
              display: flex;
              flex-direction: column;
              gap: 40px;

              .total-student-container {
                background-color: white;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

                .total-content-outer {
                  height: max-content;
                  max-height: max-content;
                }
              }
            }
          }

          .mobile-container-inner-short {
            max-height: calc(100dvh - 200px);
            overflow: hidden;
          }
        }
      }
    }
  }

  .student-tabs-container {
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow-x: auto;
    overflow-y: hidden;

    .student-tab-content {
      width: max-content;
      min-width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 16px;

      .student-tab {
        width: max-content;
        height: auto;
        background-color: #e4ecff;
        padding: 8px 16px;
        transition: background-color .3s;
        cursor: pointer;

        p {
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          transition: color .3s;
        }
      }

      .student-tab-active {
        background-color: #152751;

        p {
          color: white;
        }
      }
    }
  }

  .v2-dashboard-small {
    .v2-dashboard-section1 {
      gap: 40px;

      .v2-dashboard-section1-1 {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .comboard-container {
          .comboard-container-outer {
            max-height: calc(100dvh - 240px);
            padding: 0 16px;
          }
        }

        .event-container {
          padding: 0 16px;
        }
      }

      .v2-dashboard-section1-2 {
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 0 16px;

        .total-teacher-container,
        .total-student-container {
          width: calc((100% - 20px) / 2);
          height: auto;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        }
      }

      .v2-dashboard-section1-3 {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 0 16px;

        .v2-dashboard-section1-31 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header,
                .attendance-details {
                  width: 50%;
                }
              }
            }

            .attendance-container-group {
              gap: 20px;

              .attendance-content-group {
                width: calc((100% - 20px) / 2);
              }
            }
          }

          .teacher-list-outer {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: row;
            gap: 20px;

            .list-rank-container {
              width: calc((100% - 20px) / 2) !important;
            }
          }
        }

        .v2-dashboard-section1-32 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header,
                .attendance-details {
                  width: 50%;
                }
              }
            }
          }

          .student-list-outer {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px 20px;
          }
        }
      }
    }
  }

  .v2-dashboard-medium {
    .v2-dashboard-general-filter {
      width: 100%;
      max-width: 1280px;
      height: auto;
      // padding: 8px 16px 20px 16px;
      // margin-bottom: 20px;
      padding: 8px 16px;
      position: relative;

      // &::before {
      //   content: '';
      //   width: calc(100% - 32px);
      //   height: 1px;
      //   background-color: lightgray;
      //   position: absolute;
      //   left: 16px;
      //   top: 100%;
      // }
    }

    .v2-dashboard-section1 {
      gap: 40px;

      .v2-dashboard-section1-1 {
        width: 100%;
        display: flex;
        flex-direction: row;

        .comboard-container {
          min-width: 60%;
          max-width: auto;

          .comboard-container-outer {
            padding: 0 10px 0 16px;
            max-height: calc(100dvh - 240px);
          }
        }

        .event-container {
          min-width: 40%;
          max-width: calc(280px - 26px);
          padding: 0 16px 0 10px;

          .event-container-outer {
            .event-content {
              height: calc(100dvh - 240px - 40px - 40px) !important;

              .event-null {
                height: calc(100dvh - 240px - 40px - 40px - 16px) !important;
              }
            }
          }
        }
      }

      .v2-dashboard-section1-2 {
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 0 16px;

        .total-teacher-container,
        .total-student-container {
          width: calc((100% - 20px) / 2);
          height: auto;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        }
      }

      .v2-dashboard-section1-3 {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 0 16px;

        .v2-dashboard-section1-31 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header,
                .attendance-details {
                  width: 50%;
                }
              }
            }

            .attendance-container-group {
              gap: 20px;

              .attendance-content-group {
                width: calc((100% - 60px) / 4);
              }
            }
          }

          .teacher-list-outer {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: row;
            gap: 20px;

            .list-rank-container {
              width: calc((100% - 20px) / 2) !important;
            }
          }
        }

        .v2-dashboard-section1-32 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header,
                .attendance-details {
                  width: 50%;
                }
              }
            }
          }

          .student-list-outer {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px 20px;
          }
        }
      }
    }
  }

  .v2-dashboard-large {
    .v2-dashboard-general-filter {
      width: 100%;
      max-width: 1280px;
      height: auto;
      // padding: 8px 16px 20px 16px;
      // margin-bottom: 20px;
      padding: 8px 16px;
      position: relative;

      // &::before {
      //   content: '';
      //   width: calc(100% - 32px);
      //   height: 1px;
      //   background-color: lightgray;
      //   position: absolute;
      //   left: 16px;
      //   top: 100%;
      // }
    }

    .v2-dashboard-section1 {
      display: flex;
      flex-direction: column;
      gap: 40px;

      .v2-dashboard-section1-1 {
        width: 100%;
        display: flex;
        flex-direction: row;

        .comboard-container {
          min-width: 60%;
          max-width: auto;

          .comboard-container-outer {
            padding: 0 10px 0 16px;
            max-height: calc(100dvh - 240px);
          }
        }

        .event-container {
          min-width: 40%;
          max-width: calc(280px - 26px);
          padding: 0 16px 0 10px;

          .event-container-outer {
            .event-content {
              height: calc(100dvh - 240px - 40px - 40px) !important;

              .event-null {
                height: calc(100dvh - 240px - 40px - 40px - 16px) !important;
              }
            }
          }
        }
      }

      .v2-dashboard-section1-2 {
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 0 16px;

        .total-teacher-container,
        .total-student-container {
          width: calc((100% - 20px) / 2);
          height: auto;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        }
      }

      .v2-dashboard-section1-3 {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 0 16px;

        .v2-dashboard-section1-31 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: row;
          gap: 20px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            width: calc(((100% - 40px) / 7) * 3.8);
            height: max-content;

            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header {
                  width: 45%;
                }
                .attendance-details {
                  width: 55%;
                }
              }
            }

            .attendance-container-group {
              gap: 20px;

              .attendance-content-group {
                width: calc((100% - 20px) / 2);
              }
            }
          }

          .teacher-list-outer {
            width: calc((100% / 7) * 3.2);
            height: min-content;
            display: flex;
            flex-direction: row;
            gap: 20px;

            .list-rank-container {
              width: calc((100% - 20px) / 2) !important;

              .event-container-outer {
                .event-content {
                  height: calc(523px - 40px);

                  .event-content-outer {
                    .event-null {
                      height: calc(523px - 40px - 16px) !important;
                    }
                  }
                }
              }
            }
          }
        }

        .v2-dashboard-section1-32 {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                width: 100%;
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header {
                  width: calc(50% - 10px);
                }

                .attendance-details {
                  width: calc(50% - 10px);
                }
              }
            }
          }

          .student-list-outer {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px 20px;
          }
        }
      }
    }
  }

  .v2-dashboard-xl {
    .v2-dashboard-general-filter {
      width: 100%;
      max-width: 1280px;
      height: auto;
      // padding: 8px 16px 20px 16px;
      // margin-bottom: 20px;
      padding: 8px 16px;
      position: relative;

      // &::before {
      //   content: '';
      //   width: calc(100% - 32px);
      //   height: 1px;
      //   background-color: lightgray;
      //   position: absolute;
      //   left: 16px;
      //   top: 100%;
      // }
    }

    .v2-dashboard-section1 {
      display: flex;
      // flex-direction: row;
      flex-direction: unset;
      flex-wrap: wrap;
      gap: 40px 20px;

      .v2-dashboard-section1-1 {
        width: calc(100% - 400px - 20px);
        display: flex;
        flex-direction: row;

        .comboard-container {
          min-width: 60%;
          max-width: auto;

          .comboard-container-outer {
            padding: 0 10px 0 16px;
            max-height: calc(100dvh - 240px);
          }
        }

        .event-container {
          min-width: calc(40% - 20px);
          max-width: 320px;
          padding: 0 0 0 10px;

          .event-content {
            height: calc(100dvh - 240px - 40px - 40px) !important;

            .event-null {
              height: calc(100dvh - 240px - 40px - 40px - 16px) !important;
            }
          }
        }
      }

      .v2-dashboard-section1-2 {
        width: 400px;
        display: flex;
        flex-direction: column;
        gap: 20px;

        .total-teacher-container,
        .total-student-container {
          width: 100%;
          height: calc((100dvh - 240px - 20px) / 2) !important;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        }
      }

      .v2-dashboard-section1-3 {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 40px 20px;
        padding-left: 16px;

        .v2-dashboard-section1-31 {
          width: calc(60% - 10px);
          height: max-content;
          gap: 40px 20px;
          display: flex;
          flex-direction: column;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header,
                .attendance-details {
                  width: 50%;
                }
              }
            }

            .attendance-container-group {
              gap: 20px;

              .attendance-content-group {
                width: calc((100% - 20px) / 2);
              }
            }
          }

          .teacher-list-outer {
            width: 100%;
            gap: 20px;
            display: flex;
            flex-direction: row;
            gap: 40px 20px;

            .list-rank-container {
              width: calc((100% - 20px) / 2);
              padding-bottom: 20px;
            }
          }
        }

        .v2-dashboard-section1-31internal {
          width: 100%;
          flex-direction: row;

          .attendance-container {
            width: calc(((100% - 40px) / 7) * 3.8);
            height: max-content;

            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header {
                  width: 45%;
                }
                .attendance-details {
                  width: 55%;
                }
              }
            }

            .attendance-container-group {
              gap: 20px;

              .attendance-content-group {
                width: calc((100% - 20px) / 2);
              }
            }
          }

          .teacher-list-outer {
            width: calc((100% / 7) * 3.2);
            height: min-content;
            display: flex;
            flex-direction: row;
            gap: 20px;

            .list-rank-container {
              width: calc((100% - 20px) / 2) !important;

              .event-container-outer {
                .event-content {
                  height: calc(523px - 40px);

                  .event-content-outer {
                    .event-null {
                      height: calc(523px - 40px - 16px) !important;
                    }
                  }
                }
              }
            }
          }
        }

        .v2-dashboard-section1-32 {
          width: calc((40% - 10px));
          gap: 20px 20px;
          display: flex;
          flex-direction: column;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                .attendance-header,
                .attendance-details {
                  margin-bottom: 20px;
                }
              }
            }
          }

          .student-list-outer {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 40px 20px;
          }

          .student-list-swap {
            width: 100%;
            max-width: 100%;
            height: auto;
            overflow: hidden;

            .student-list-swap-tabs {
              width: 400%;
              position: relative;
              display: flex;
              flex-direction: row;
              transition: margin-left .6s;

              .list-student-container {
                width: 100% !important;
              }
            }
          }
        }

        .v2-dashboard-section1-3teacher {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 40px;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          padding: 16px;

          .attendance-container {
            .attendance-content-outer {
              background-color: none !important;
              box-shadow: none !important;
              padding: 0 !important;

              .attendance-header-container {
                width: 100%;
                display: flex;
                flex-direction: row;
                gap: 20px;

                .attendance-header {
                  width: calc(50% - 10px);
                }

                .attendance-details {
                  width: calc(50% - 10px);
                }
              }
            }
          }

          .student-list-outer {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px 20px;
          }
        }
      }

      // .v2-dashboard-section1-2 {
      //   display: flex;
      //   flex-direction: row;
      //   gap: 20px;

      //   .event-container {
      //     width: calc((100% - 20px) / 2);
      //     padding-right: 16px;

      //     .event-content {
      //       height: calc(100dvh - 60px - 32px - 24px - 40px - 40px);
      //     }
      //   }

      //   .attendance-container {
      //     width: calc((100% - 20px) / 2);
      //     padding-right: 0;

      //     .attendance-content-outer {
      //       height: calc(100dvh - 60px - 32px - 24px) !important;
      //       display: flex;
      //       flex-direction: column;
      //       align-items: center;
      //       justify-content: center;
      //       gap: 80px;

      //       .attendance-header {
      //         p {
      //           font-size: 16px;
      //           line-height: 24px;

      //           &:nth-child(1) {
      //             font-size: 86px;
      //             line-height: 100px;
      //             margin-bottom: 8px;
      //             font-weight: 500;
      //           }
      //         }

      //         &::before {
      //           content: '';
      //           width: 100%;
      //           height: 1px;
      //           background-color: lightgray;
      //           position: absolute;
      //           left: 0;
      //           bottom: -39.5px;
      //         }
      //       }
      //     }
      //   }
      // }
    }
  }

  .v2-dashboard-large,
  .v2-dashboard-xl {
    .v2-dashboard-section1 {
      // width: 100%;
      // height: auto;
      // display: flex;
      // flex-direction: row;
      // align-items: start;

      // .comboard-container {
      //   width: 680px;
      //   max-width: 680px;

      //   .comboard-container-outer {
      //     height: calc(100dvh - 60px - 32px - 24px);
      //     max-height: calc(100dvh - 60px - 32px - 24px);

      //     .comboard-content {
      //       padding: 0 0 28px 16px;
      //     }
      //   }
      // }

      // .v2-dashboard-section1-2 {
      //   width: calc(100% - 680px - 20px);
      // }
    }
  }

  .v2-filter-mobile {
    width: 60px;
    height: 60px;
    background-color: #152751;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 40px;
    right: 16px;
    z-index: 10;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    cursor: pointer;

    svg {
      path {
        fill: white;
      }
    }
  }

  .v2-filter-mobile-container {
    width: calc(100vw - 32px);
    height: auto;
    position: fixed;
    bottom: 108px;
    left: 16px;
    z-index: 8;
    background-color: white;
    padding: 16px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    cursor: default;
  }
</style>
